import {fetchDataFromApi} from './apiHelper';

export const usersFields = () => fetchDataFromApi('post', '/api/user/fields');
export const fetchMissedRowsStatisticFields = () => fetchDataFromApi('post', '/api/report-ads-txt/getstat');
export const fetchUsersData = () => fetchDataFromApi('post', '/api/logs/users');
export const fetchAccManagers = () => fetchDataFromApi('post', '/api/user/managers');
export const fetchPubManagers = () => fetchDataFromApi('post', '/api/user/pubmanagers');